import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-copy',
    templateUrl: './copy.component.html',
    styleUrls: ['./copy.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CopyComponent implements OnInit {
  @Input() content: string;

  constructor() {}

  ngOnInit(): void {}
}
